﻿﻿import { IMatchCounts } from './match-counts';

export interface IDonorAboCount {
    abo: string;
    countOfCurrent: number;
    countOfLastYear: number;
}
export interface IDonorsPerMonthByAbo {
    counts: IDonorAboCount[];
}
